module.exports = __webpack_public_path__ + "img/photo-07.e6e43a4d.webp";